import React from 'react';
import {View} from 'react-native';
import type {TimeSlotType} from 'src/types/Menu';
import TransactionStore from 'src/stores/TransactionStore';
import {WithLocalizedProps} from 'src/types/PropTypes';
import {LocationType} from 'src/types/Location';
import {getDescriber} from './descriptor/DescriptorType';
import AccountStore from 'src/stores/AccountStore';
import {injectIntl, IntlShape} from 'react-intl';
import {formatCurrency} from 'src/i18n/helpers/formatCurrency';

const {checkoutBarUI} = getDescriber();

type CheckoutBarProps = WithLocalizedProps & {
  location: LocationType;
  onPress?: () => void;
  intl: IntlShape;
};

type CheckoutBarState = {
  numItems: number;
  pickupTime?: TimeSlotType;
  displayLocation: string;
  totalAmount?: number;
};

class CheckoutBar extends React.Component<CheckoutBarProps, CheckoutBarState> {
  constructor(props: CheckoutBarProps) {
    super(props);
    this.onTransactionStoreChanged = this.onTransactionStoreChanged.bind(this);
    this.getNumItems = this.getNumItems.bind(this);
    const numItems = this.getNumItems();
    const pickupLocation = TransactionStore.getPickupLocationName();

    this.state = {
      numItems,
      pickupTime: TransactionStore.getPickupTime(),
      displayLocation: pickupLocation || props.location?.name,
      totalAmount: parseFloat(TransactionStore.getTransaction()?.Due) ?? 0,
    };
  }

  componentDidMount() {
    TransactionStore.addChangeListener(this.onTransactionStoreChanged);
  }

  componentWillUnmount() {
    TransactionStore.removeChangeListener(this.onTransactionStoreChanged);
  }

  onTransactionStoreChanged() {
    const numItems = this.getNumItems();
    const pickupTime = TransactionStore.getPickupTime();
    const pickupLocation = TransactionStore.getPickupLocationName();
    const totalAmount = parseFloat(TransactionStore.getTransaction().Due) ?? 0;

    this.setState({
      numItems,
      pickupTime,
      displayLocation: pickupLocation || this.props.location?.name,
      totalAmount,
    });
  }

  getNumItems() {
    const displayItems = TransactionStore.getDisplayItems();
    return displayItems?.length;
  }

  render() {
    const Due = this.state.totalAmount;
    const totalAmount = formatCurrency(
      this.props.intl,
      Due,
      AccountStore.getCurrency(),
      {
        maximumFractionDigits: 2,
        useGrouping: true,
      },
    );
    return (
      <View>
        {checkoutBarUI({
          numItems: this.state.numItems,
          pickupTime: this.state.pickupTime,
          displayLocation: this.state.displayLocation,
          onPress: this.props.onPress,
          totalAmount,
        })}
      </View>
    );
  }
}
export default injectIntl(CheckoutBar);
